import React, { useRef } from "react";
import api from "./../../../const/axios";
import { ImagePlus } from "lucide-react";
import siteUrl from "./../../../const/const";

interface BannerUploaderProps {
  imageUrl: string;
  imageUpload: (url: string, mediaId: any) => void;
}

const BannerUploader: React.FC<BannerUploaderProps> = ({ imageUrl, imageUpload }) => {
  const inputRef = useRef<HTMLInputElement>(null);

  const handleFile = async (file: File) => {
    const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
    if (!isJpgOrPng) {
      alert("Yalnızca png və jpg formatında şəkillər yükləyə bilərsiniz.");
      return;
    }
    if (file.size / 1024 / 1024 >= 5) {
      alert("Faylın ölçüsü 5 meqabaytdan kiçik olmalıdır.");
      return;
    }
    const formData = new FormData();
    const filename = Math.floor(Math.random() * 999999) + 1 + Date.now() + "_" + file.name;
    formData.append("file", file, filename);
    try {
      const res = await api.post("users/photo", formData, {
        headers: { "content-type": "multipart/form-data" },
      });
      imageUpload(res.data.name, res.data.id);
    } catch {
      alert("Yükləmə zamanı xəta baş verdi");
    }
  };

  return (
    <div
      onClick={() => inputRef.current?.click()}
      className="w-full h-32 rounded-xl border-2 border-dashed border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-950 flex items-center justify-center cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors overflow-hidden"
    >
      {imageUrl ? (
        <img
          src={`${siteUrl}images/temp/${imageUrl}`}
          alt="banner"
          className="w-full h-full object-cover"
        />
      ) : (
        <div className="flex flex-col items-center gap-2 text-gray-400 dark:text-gray-500">
          <ImagePlus className="w-6 h-6" />
          <span className="text-sm font-medium">Banner Yüklə</span>
        </div>
      )}
      <input
        ref={inputRef}
        type="file"
        accept="image/jpeg,image/png"
        className="hidden"
        onChange={e => {
          const f = e.target.files?.[0];
          if (f) handleFile(f);
        }}
      />
    </div>
  );
};

export default BannerUploader;
